<template>
  <b-container class="mt-5">
    <b-row>
      <b-col>
        <b-breadcrumb :items="breadcrumb" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <b-row>
          <b-col md="3">
            <b-img thumbnail fluid :src="img.location" alt="Image 1" class="mb-3" v-for="img in product.images" v-bind:key="img.key"/>
          </b-col>
          <b-col md="9">
            <b-img-lazy v-bind="mainProps" :src="getImageUrl(80)" alt="Image 1" />
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="6">
        <b-row>
          <b-col cols="12">
            <h3 class="text-purple">{{ product.name }}</h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <h4 class="text-primary">{{ product.price | toCurrency }} MXN</h4>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
            <h6 class="text-muted">Disponible: {{ product.quantityAvailable }}</h6>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6" class="pt-1 pb-3">
            <b-form-rating readonly variant="warning" show-value :value="calculateRating(product)"></b-form-rating>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12">
            <b-button-group>
              <b-button @click="onShareToFacebook(product)" variant="outline-primary">
                <font-awesome-icon :style="{ color: 'info' }" :icon="['fab', 'facebook-square']"/>
              </b-button>
              <b-button @click="onShareToTwitter(product)" variant="outline-success">
                <font-awesome-icon :icon="['fab', 'twitter']"/>
              </b-button>
              <b-button @click="onShareToWhatsapp(product)" variant="outline-success">
                <font-awesome-icon :icon="['fab', 'whatsapp']"/>
              </b-button>
              <b-button @click="onShareToEmail(product)" variant="outline-info">
                <font-awesome-icon :icon="['fas', 'envelope']"/>
              </b-button>
            </b-button-group>
          </b-col>
        </b-row>
        <b-row v-if="product.quantityAvailable > 0">
          <b-col cols="4" class="pt-3">
            <b-input-group>
              <b-input-group-prepend>
                <b-button variant="outline-secondary" @click="onDecreaseQuantity">-</b-button>
              </b-input-group-prepend>
              <b-form-input id="input-quantity" type="number" :min="1" :max="product.quantityAvailable" v-model="quantity" />
              <b-input-group-append>
                <b-button variant="outline-primary" @click="onIncreaseQuantity">+</b-button>
              </b-input-group-append>
              </b-input-group>
          </b-col>
          <b-col cols="5" class="pt-3">
            <b-button variant="purple" @click="onAddToCart(product)">
              <font-awesome-icon :icon="['fas', 'shopping-cart']"/> Agregar al carrito
            </b-button>
          </b-col>
        </b-row>
        <b-row v-else>
          <b-col cols="6" class="pt-3">
            <b-input-group prepend="@">
              <b-form-input type="email" placeholder="Ingrese su email"></b-form-input>
            </b-input-group>
          </b-col>
          <b-col cols="6" class="pt-3">
            <b-button variant="outline-purple" @click="onNotifyMe(product)">
              Notificarme disponibilidad
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="pt-3">
            <hr>
            <div v-html="product.description"></div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-overlay :show="overlay" rounded="sm" fixed no-wrap />
  </b-container>
</template>

<script>
export default {
  name: 'Product',
  async mounted () {
    await this.fetch()
  },
  computed: {
    images () {
      return this.product.images.map(img => img.location)
    }
  },
  data () {
    return {
      overlay: true,
      quantity: 1,
      breadcrumb: [{ text: 'Home', to: '/' }],
      mainProps: {
        center: true,
        fluidGrow: true,
        blank: true,
        blankColor: '#bbb',
        width: 600,
        height: 400
      },
      product: { images: [] }
    }
  },
  methods: {
    async fetch () {
      const response = await this.$http.get(`/products/${this.$route.params.slug}`)
      this.product = response.data
      this.breadcrumb = [
        { text: 'Home', to: '/' },
        { text: this.product.category.name, to: `/catalog/${this.product.category.slug}` },
        { text: this.product.name, active: true }
      ]
      this.overlay = false
    },
    onDecreaseQuantity () {
      if (this.quantity < 2) return
      this.quantity -= 1
    },
    onIncreaseQuantity () {
      if (this.quantity === this.product.quantityAvailable) return
      this.quantity += 1
    },
    onAddToCart (item) {
      item.quantity = this.quantity
      this.$store.commit('addToCart', item)
      this.$bvToast.toast(`Se agregó ${item.name} a tu carrito.`, {
        title: 'Artículo agregado',
        solid: true
      })
    },
    getImageUrl (imageId) {
      // const { width, height } = this.mainProps
      return this.images[0]
    },
    onShareToFacebook () {

    },
    onShareToTwitter () {

    },
    onShareToWhatsapp () {

    },
    onShareToEmail () {

    },
    onNotifyMe () {

    },
    calculateRating (item) {
      if (!item.votes || (item.votes && item.votes.length === 0)) return 0

      const sum = item.votes.reduce((acc, row) => {
        return acc + row.vote
      }, 0)
      return sum / item.votes.length
    }
  }
}
</script>
